export const DUPLICATE_FLAG_ID_QUERY_PARAM = 'duplicateFlagId';
